import React, { useEffect, useState } from 'react';
import MemberLayout from '../../components/MemberLayout';
import { getMyProfile } from '../../services/api';

export default function MyMembership() {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    getMyProfile().then((res) => setProfile(res.data)).catch(() => {});
  }, []);

  if (!profile) return <MemberLayout title="My Membership"><p>Loading...</p></MemberLayout>;

  return (
    <MemberLayout title="My Membership">
      <div className="card" style={{ maxWidth: 560 }}>
        <div className="grid grid-2">
          <div><div className="stat-label">Membership Number</div><p><strong>{profile.membershipNumber}</strong></p></div>
          <div><div className="stat-label">Status</div><p><span className="badge badge-pending">{profile.status}</span></p></div>
          <div><div className="stat-label">Package</div><p>{profile.packageName || '—'}</p></div>
          <div><div className="stat-label">Joining Date</div><p>{profile.joiningDate}</p></div>
          <div><div className="stat-label">Renewal / Expiry Date</div><p>{profile.expiryDate || '—'}</p></div>
          <div><div className="stat-label">Province</div><p>{profile.province}</p></div>
        </div>
        <div style={{ marginTop: 20, padding: 14, background: '#f7f5ef', borderRadius: 4, fontSize: '0.85rem' }}>
          Online membership renewals are coming in a future update. For now, please contact us via WhatsApp to renew.
        </div>
      </div>
    </MemberLayout>
  );
}
